const AuthPageLayout = ({ children, className = '' }: any) => {
    return (
        <div
            className={`md:w-[28.5rem] md:h-auto md:min-h-[30rem] w-full h-full flex flex-col items-center justify-center bg-white md:rounded-2xl relative shadow-md ${className}`}
        >
            {children}
        </div>
    );
};

export default AuthPageLayout;
